import React from 'react';
import {
    ReferenceArrayInput,
    SelectArrayInput,
} from 'react-admin';

const ParticipantsInput = (props) => (
    <ReferenceArrayInput
        source="participant_ids"
        reference="users"
        {...props}
    >
        <SelectArrayInput
            optionText="fullname"
            label="Participants"
        />
    </ReferenceArrayInput>
);

export default ParticipantsInput;
